// automatically register svg files from  svg folder  
const req = require.context('./svg', false, /\.svg$/); // function webpackContext(req){...}  
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)